import { useLingui } from '@lingui/react/macro';

/**
 * A modifier for trial copy, not a standalone duration. Display 365 days as
 * "1-year" without changing backend durations.
 */
export function useFreeTrialDuration(days: number): string {
  const { t } = useLingui();
  return days === 365
    ? t({
        message: '1-year',
        context: 'Free-trial duration modifier',
        comment:
          'Used inside trial sentences. Match their grammar: Norwegian needs an adjectival form; French includes the connecting preposition; German uses a plain duration with a preposition.',
      })
    : t({
        message: `${days}-day`,
        context: 'Free-trial duration modifier',
        comment:
          'Used inside trial sentences. Match their grammar: Norwegian needs an adjectival form; French includes the connecting preposition; German uses a plain duration with a preposition.',
      });
}

export function useFreeTrialLengthText(days: number): string {
  const { t } = useLingui();
  const trialDuration = useFreeTrialDuration(days);
  return t`${trialDuration} free trial`;
}
